<template>
  <div class="invoice-statusbadge--wrap">
    <div class="status-badge" :class="['status-' + invoice.display_status.detailed_status]">    
      <div v-if="invoice && isQuotation" class="status-badge-wrap">
        <div v-if="invoice.status === 'draft'">
          <font-awesome-icon icon="fa-regular fa-envelope" />
          {{ $gettext('This quotation is saved as a draft.') }}
          <GekkoButton
            :to="{ name: 'QuotationSend', params: { quotationId: invoice.id } }"
            :text="$gettext('Send quotation')"
            variant="link"
            class="p-0"
          />
        </div>
        <div v-if="invoice.status === 'shared'">
          <font-awesome-icon icon="fa-regular fa-envelope-circle-check" />
          {{ $gettext('This quotation is sent.') }}
        </div>
        <div v-if="invoice.status === 'accepted'">
          <font-awesome-icon icon="fa-regular fa-circle-check" />
          {{ $gettext('This quotation has been accepted.') }}
        </div>
        <div v-if="invoice.status === 'rejected'">
          <font-awesome-icon icon="fa-regular fa-triangle-exclamation" />
          {{ $gettext('This quotation has been rejected.') }}
        </div>
        <div v-if="invoice.status === 'invoiced'">
          <font-awesome-icon icon="fa-regular fa-circle-check" />
          {{ $gettext('This quotation has been invoiced.') }}
        </div>
      </div>

      <div v-if="invoice && !isCorrection && !isUploaded && !isQuotation" class="status-badge-wrap">
        <div v-if="invoice.status === 'd'">
          <font-awesome-icon icon="fa-regular fa-envelope" />
          {{ $gettext('This invoice is saved as a draft.') }}
          <GekkoButton
            :to="{ name: 'InvoiceSend', params: { invoiceId: invoice.id } }"
            :text="$gettext('Send invoice')"
            variant="link"
            class="p-0"
          />
        </div>
        <div v-if="invoice.status === 's'">
          <font-awesome-icon icon="fa-solid fa-sack-dollar" />
          {{ $gettext('This invoice is sent but not yet paid.') }}
          <GekkoButton
            :to="{ name: 'InvoicePayments', params: { invoiceId: invoice.id } }"
            :text="$gettext('Add payment')"
            variant="link"
            class="p-0"
          />
        </div>
        <div v-if="invoice.status === 'o'">
          <font-awesome-icon icon="fa-regular fa-triangle-exclamation" />
          {{ $gettext('Payment for this invoice is overdue.') }}
          <GekkoButton
            :to="{ name: 'InvoiceSend', params: { invoiceId: invoice.id } }"
            :text="$gettext('Send reminder')"
            variant="link"
            class="p-0"
          />
        </div>
        <div v-if="invoice.status === 'p'">
          <font-awesome-icon icon="fa-regular fa-circle-check" />
          {{ $gettext('This invoice is sent and payment has been received.') }}
        </div>
      </div>

      <StatusIcons :item="invoice" />

    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import GekkoButton from "@/components/GekkoButton"
import StatusBadge from "@/components/invoices/ui/StatusBadge"
import StatusIcons from "@/components/invoices/ui/StatusIcons"

export default {
  name: 'InvoiceStatusBadge',
  components: {
    GekkoButton,
    StatusBadge,
    StatusIcons
  },
  props: {
    isQuotation: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({ 
      invoice: "invoices/getInvoice",
    }),
    isCorrection () {
      return (this.invoice && this.invoice.correction && this.invoice.correction !== null)
    },
    isUploaded () {
      return (this.invoice && this.invoice.uploaded)
    },
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
  .invoice-statusbadge {
    &--wrap {
      width: 100%;
      // height: 40px;
      > .status-badge {
        width: 100%;
        height: 100%;
        padding: 0.5rem;
        border-radius: $radiusMd;
        text-align: left;
        display: flex;
        justify-content: flex-start;
        gap: 0.5rem;
        white-space: normal;
        .status-badge-wrap {
          font-size: 14px;
          text-transform: none;
          .svg-inline--fa {
            margin-right: 0.25rem;
            opacity: 0.7;
          }
        }
        .status-badge { 
          width: auto;
          padding: 0;
          font-size: 14px;
          text-transform: none;
        }
      }
    }
    @media (min-width: '768px') {
      &--wrap {
        height: 50px; 
        > .status-badge {
          padding: 1rem;
          .status-badge-wrap {
            font-size: 1rem;
          }
          .status-badge { 
            font-size: 1rem;
          }
        }
      }
    }
  }
</style>